module.exports = __webpack_public_path__ + "img/card-checklist.23f0eb90.svg";